import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import Modal from 'app/services/modals';
import Config from 'app/services/config';
import formValidate from 'app/directives/form.validation';
import CustomerStore from 'app/stores/customer';
import TicketList from 'app/tickets/components/list';
import OrderList from 'app/orders/components/list';
import SalesPersonPicker from 'app/directives/sales_person.picker';
import SalesPeoplePicker from 'app/directives/sales.picker';
import Activity from 'app/directives/activity';
import UploadComponent from 'app/directives/upload.section';
import CustomerDefaultDeliveryPicker from 'app/directives/blnd.customer.delivery.picker';
import HitPercentageButton from 'app/directives/hide-customer.button/component';

import Fields from './fields/routing';

import {ListCtrl, DetailCtrl, InfoCtrl, OrderListCtrl, TicketListCtrl, FilesCtrl, LogCtrl, CustomerNotificationsCtrl} from './ctrls';

import listTpl from './list.html';
import detailTpl from './detail.html';
import infoTpl from './info.html';
import orderListTpl from './order.list.html';
import ticketListTpl from './ticket.list.html';
import filesTpl from './files.html';
import logTpl from './log.html'
import notificationsTpl from './notifications.html'

function detailController(legacyController) {
    return ['Config', function (Config) {
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL')
            ? function () {}
            : legacyController;
    }];
}

function detailTemplate(legacyTemplate) {
    return ['Config', function (Config) {
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL')
            ? '<div style="display:none"></div>'
            : legacyTemplate;
    }];
}

@Module({
    name: 'app.customers',
    modules: [
        BaseRoute,
        CustomerStore,
        Modal,
        Config,
        formValidate,
        Fields,
        TicketList,
        OrderList,
        SalesPersonPicker,
        SalesPeoplePicker,
        CustomerDefaultDeliveryPicker,
        HitPercentageButton,
        UploadComponent,
        Activity,
    ],
})
@State({
    name: 'r.in.top.customers',
    url: '/customers',
    template: '<div ui-view></div>',
    abstract: '.list',
    ncyBreadcrumb: {
        skip: true,
    },
    data: {
        permissions: {
            only: [
                'main.view_customer',
            ]
        }
    }
})
@State({
    name: 'r.in.top.customers.list',
    url: '?search&companies&sales&page&ordering',
    // The React page owns these query params (it writes them directly and
    // refetches itself); the legacy fallback also drives them via UI + an
    // explicit `$state.go('.', ..., {notify: false})`. Neither relies on the
    // state reloading when they change, so disable it - otherwise Angular
    // remounts the React island (and reconciles a stale `$location`) on every
    // paginate/filter, causing flicker and the "click navbar twice" bug.
    reloadOnSearch: false,
    // Feature flag managed by the backend controls the React list rollout.
    controllerProvider: function (Config) {
        "ngInject";
        const useReact = Config.isFeatureFlagActive('REACT_CUSTOMERS_LIST');
        return useReact ? function () {} : ListCtrl;
    },
    templateProvider: function (Config) {
        "ngInject";
        const useReact = Config.isFeatureFlagActive('REACT_CUSTOMERS_LIST');
        return useReact
            ? `<div react-view="customers-list"></div>`
            : listTpl;
    },
    ncyBreadcrumb: {
        label: 'Customers',
    },
})
@State({
    name: 'r.in.top.customers.detail',
    url: '/:customerId',
    controllerProvider: function (Config) {
        "ngInject";
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL')
            ? function ($customer, $scope) {
                "ngInject";
                this.customer = $customer;
                this.onCustomerUpdated = (customer) => $scope.$applyAsync(() => {
                    this.customer = customer;
                });
            }
            : DetailCtrl;
    },
    as: 'pvm',
    templateProvider: function (Config) {
        "ngInject";
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL')
            ? '<div react-view="customer-detail" props="{customer: pvm.customer, onCustomerUpdated: pvm.onCustomerUpdated}"></div><div ui-view style="display:none"></div>'
            : detailTpl;
    },
    resolve: {
        $customer: function($stateParams, CustomerStore) {
            return CustomerStore.get($stateParams.customerId);
        },
    },
    ncyBreadcrumb: {
        label: '{{pvm.customer.title}}',
        parent: 'r.in.top.customers.list',
    },
    abstract: '.info',
})
@State({
    name: 'r.in.top.customers.detail.info',
    url: '',
    controllerProvider: detailController(InfoCtrl),
    templateProvider: detailTemplate(infoTpl),
    resolve: {
    },
    ncyBreadcrumb: {
        label: 'Info',
    },
})
@State({
    name: 'r.in.top.customers.detail.orders',
    url: '/orders?company&search&created_at__range&status&page',
    reloadOnSearch: false,
    controllerProvider: detailController(OrderListCtrl),
    templateProvider: detailTemplate(orderListTpl),
    resolve: {
    },
    ncyBreadcrumb: {
        label: 'Orders',
    },
})
@State({
    name: 'r.in.top.customers.detail.tickets',
    url: '/tickets?company&search&created_at__range&status&page',
    reloadOnSearch: false,
    controllerProvider: detailController(TicketListCtrl),
    templateProvider: detailTemplate(ticketListTpl),
    resolve: {
    },
    ncyBreadcrumb: {
        label: 'Tickets',
    },
})
@State({
    name: 'r.in.top.customers.detail.files',
    url: '/files',
    controllerProvider: detailController(FilesCtrl),
    templateProvider: detailTemplate(filesTpl),
    resolve: {
    },
    ncyBreadcrumb: {
        label: 'Files',
    },
})
@State({
    name: 'r.in.top.customers.detail.log',
    url: '/log',
    controllerProvider: detailController(LogCtrl),
    templateProvider: detailTemplate(logTpl),
    ncyBreadcrumb: {
        label: 'Log',
    },
})
@State({
    name: 'r.in.top.customers.detail.notifications',
    url: '/notifications',
    controllerProvider: detailController(CustomerNotificationsCtrl),
    templateProvider: detailTemplate(notificationsTpl),
    ncyBreadcrumb: {
        label: 'Notifications',
    },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/customers/routing.js